import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AdminTeacherPayoutVM, TeacherPayoutListPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";
import type { Dependencies } from "@redux/store";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";

export const adminRetrieveTeacherPayouts = createAsyncThunk<
  PaginatedResult<AdminTeacherPayoutVM>,
  TeacherPayoutListPaginationParams,
  { extra: Partial<Dependencies> }
>("payouts/adminRetrieveTeacherPayouts", async (params: TeacherPayoutListPaginationParams, { extra: { adminRepository } }) => {
  return adminRepository!.getAdminTeacherPayouts(params);
});
